import { DefaultService } from '@/services/DefaultService';

export default class FlexService extends DefaultService {
    findAll(filtros) {
        return this._http
            .post(encodeURI(`${this._env}/flex.json`), filtros, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    find(uuid) {
        return this._http
            .get(`${this._env}/flex/uuid/${uuid}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findByIdCustom(id) {
        return this._http
            .get(`${this._env}/flex/get-by-id-custom/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateSituacao(flex) {
        return this._http
            .post(
                `${this._env}/flex/update-situacao`,
                flex,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateContaFlex(flex) {
        return this._http
            .post(
                `${this._env}/flex/update.json`,
                flex,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    save(form) {
        return this._http
            .post(
                `${this._env}/flex/saveContaWithLancamento.json`,
                form,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
